import React from "react";
import {
  Card,
  Text,
  BlockStack,
  InlineStack,
  Select,
  Button,
  Divider,
  Icon,
  Link
} from "@shopify/polaris";
import { CircleTickMinor } from "@shopify/polaris-icons";

/**
 * Storefront status: the app embed and each theme app block in the selected theme, with a link to fix what's off.
 * The theme picker drives the whole dashboard, so the theme state lives with the caller (useThemeExtensionStatus).
 */
const ThemeStatus = ({
  themeOptions = [],
  selectedThemeId = null,
  onThemeChange = () => {},
  isAppEmbedActive = false,
  appEmbedDeepLink = "",
  supportsAppBlocks = true,
  blocks = []
}) => (
  <Card>
    <BlockStack gap="300">
      <Text variant="headingSm" as="h2">Storefront status</Text>
      {themeOptions.length > 0 && (
        <Select
          label="Theme"
          labelHidden
          options={themeOptions}
          value={selectedThemeId || ""}
          onChange={onThemeChange}
        />
      )}
      <StatusRow
        name="App embed"
        on={isAppEmbedActive}
        onLabel="Active"
        action={<Button variant="primary" size="slim" url={appEmbedDeepLink} target="_blank">Turn on</Button>}
      />
      {!isAppEmbedActive && (
        <Text variant="bodySm" as="p" tone="critical">
          Widgets won't show on your store until this is on.
        </Text>
      )}
      <Divider />
      {supportsAppBlocks ? blocks.map(block => (
        <StatusRow
          key={block.handle}
          name={block.name}
          on={block.enabled}
          onLabel="Placed"
          action={<Link url={block.deepLink} target="_blank">Add</Link>}
        />
      )) : (
        <Text variant="bodySm" as="p" tone="subdued">This theme doesn't support app blocks.</Text>
      )}
    </BlockStack>
  </Card>
);

const StatusRow = ({ name, on, onLabel, action }) => (
  <InlineStack align="space-between" blockAlign="center" wrap={false}>
    <Text as="span">{name}</Text>
    {on ? (
      <InlineStack gap="100" blockAlign="center" wrap={false}>
        <span><Icon source={CircleTickMinor} tone="success" /></span>
        <Text as="span" tone="success">{onLabel}</Text>
      </InlineStack>
    ) : action}
  </InlineStack>
);

export default ThemeStatus;
